import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class StorageService 
{

    public data: Object | string;

    constructor() {
    }

    public getData(): Object | string 
    {
        return this.data;
    }

    public setData(data: any): void 
    {
        this.data = data;
    }
}